import { CartItem, EnumFlashSaleStatus } from '@/page/shoppingCar/views/api';
import { memo, useEffect, useState } from 'react';
import { Animated, View, Text, TouchableOpacity } from 'react-native';
import Image from '@kds/image';
import { Styles } from '../addOnHelperStyle';
import imgLiving from '@/assets/images/living.gif';
import React from 'react';
import { $k18n } from '@/common/i18n';
import { vIf } from '@/common/utils/vIf';
import { ViewVisible } from '@/component/ViewVisible/ViewVisible';
import FlashIcon from '@/page/shoppingCar/views/components/FlashIcon';
import { onFlashVisible } from '@/page/shoppingCar/views/logger';
import iconCartBtn from '@/assets/icon/icon_cart_btn.png';
import { ButtonWrapper } from '@/component/Button/Button';

const defaultCoupon = (coupon) => {
    return vIf(
        !!coupon.text,
        <View style={Styles.itemRow.infoRow.detailInfoCol.tagItemView}>
            <Text style={Styles.itemRow.infoRow.detailInfoCol.tagItem}>{coupon.text}</Text>
        </View>,
    );
};

const MemoCartIcon = memo(() => {
    return <Image style={Styles.actionBox.cartBtnIcon} source={iconCartBtn} />;
});

export const Item = (props: {
    item: CartItem;
    showCartProp: boolean;
    shopInfoProp: any;
    aniItemRef: number;
    onCountDownFinish: Function;
    setParams: {
        setCurItemId: Function;
        setCurItem: Function;
        setShowPop: Function;
    };
    model?: any;
}) => {
    const { item, aniItemRef, setParams, showCartProp, shopInfoProp, onCountDownFinish, model = {} } = props;
    const index = item.index;

    const [showFlash, setShowFlash] = useState(
        item?.flashSaleStatus === EnumFlashSaleStatus.Flash || item?.flashSaleStatus === EnumFlashSaleStatus.SnatchUp,
    );
    // 12h内展示倒计时，其余时间展示秒杀标签
    const [showFlashCuntDown, setShowFlashCuntDown] = useState(item?.flashSaleEndTime && item?.flashSaleEndTime < 12 * 60 * 60 * 1000);
    useEffect(() => {
        setShowFlash(item?.flashSaleStatus === EnumFlashSaleStatus.Flash || item?.flashSaleStatus === EnumFlashSaleStatus.SnatchUp);
        setShowFlashCuntDown(item?.flashSaleEndTime && item?.flashSaleEndTime < 12 * 60 * 60 * 1000);
    }, [item.flashSaleEndTime, item.flashSaleStatus]);

    return (
        <ButtonWrapper
            key={item.cartItemId}
            onPress={() => {
                model.gotoDetail(item);
            }}
        >
            <Animated.View style={[Styles.itemRow.value]}>
                <View style={Styles.rowFlex}>
                    <View style={Styles.itemRow.infoRow.imgInfoCol.value}>
                        {/* 限首次购买 > 正在讲解 > 序号 */}
                        {(() => {
                            // 正在讲解
                            if (item.areaStatus === 2)
                                return (
                                    <View style={Styles.itemRow.infoRow.imgInfoCol.explaining.value}>
                                        <View>
                                            <Image style={Styles.itemRow.infoRow.imgInfoCol.explaining.image} source={imgLiving} />
                                        </View>
                                        <Text style={Styles.itemRow.infoRow.imgInfoCol.explaining.font}>{$k18n('正在讲解')}</Text>
                                    </View>
                                );
                            // 序号
                            return (
                                <View style={Styles.itemRow.infoRow.imgInfoCol.topTipsView}>
                                    <Text style={Styles.itemRow.infoRow.imgInfoCol.topTips}>{index + 1}</Text>
                                </View>
                            );
                        })()}
                        <View>
                            <Image source={{ uri: item.coverUrl }} style={Styles.itemRow.infoRow.imgInfoCol.cover.value} />
                        </View>
                        {vIf(item.code && !!item.codeDesc, <Text style={Styles.itemRow.infoRow.imgInfoCol.bottomTips}>{item.codeDesc}</Text>)}
                        {vIf(
                            !!item.discountAmount,
                            // iosrn tip： text底色会生效 但是圆角不生效 圆角需要加在text外层的view上
                            <View style={Styles.itemRow.infoRow.imgInfoCol.bottomTipsView}>
                                <Text style={Styles.itemRow.infoRow.imgInfoCol.bottomTips}>{item.discountAmount}</Text>
                            </View>,
                        )}
                    </View>
                    <View style={Styles.itemRow.infoRow.detailInfoCol.value}>
                        <Text style={Styles.itemRow.infoRow.detailInfoCol.titleRow} numberOfLines={2}>
                            {item.name}
                        </Text>
                        <View style={Styles.itemRow.infoRow.detailInfoCol.tagsRow}>
                            {
                                // 展示：秒杀标签
                                showFlash ? (
                                    <ViewVisible onVisible={() => onFlashVisible({ item_id: item.commodityId })}>
                                        <FlashIcon item={item} setShowFlash={setShowFlash} showFlashCuntDown={showFlashCuntDown} />
                                    </ViewVisible>
                                ) : null
                            }
                            {
                                /* 优惠券 */
                                item.couponList?.map((coupon) => {
                                    return coupon.couponType === '3' ? defaultCoupon(coupon) : null;
                                })
                            }
                            {
                                // 倒计时<12hours才展示
                                showFlash && showFlashCuntDown && item.flashSaleGapHitDesc ? (
                                    <Text style={Styles.itemRow.infoRow.detailInfoCol.countDownTagItem}>{item.flashSaleGapHitDesc}</Text>
                                ) : null
                            }
                        </View>
                        <View style={Styles.itemRow.infoRow.detailInfoCol.bottomRow.value}>
                            {/* 区间价， 展示逻辑： 秒杀价 > 分期价 > 起步价 > 券后价 > 划线价 */}
                            <View>
                                {(() => {
                                    // 有秒杀价，优先展示秒杀价
                                    if (showFlash) {
                                        return (
                                            <>
                                                <Text
                                                    numberOfLines={1}
                                                    ellipsizeMode={'tail'}
                                                    style={Styles.itemRow.infoRow.detailInfoCol.bottomRow.guidePrice.guide}
                                                >
                                                    {item.displayGuidePrice}
                                                </Text>
                                                <Text
                                                    numberOfLines={1}
                                                    ellipsizeMode={'tail'}
                                                    style={Styles.itemRow.infoRow.detailInfoCol.bottomRow.guidePrice.price}
                                                >
                                                    {item.displaySalePrice}
                                                </Text>
                                            </>
                                        );
                                    }
                                    // 如果有分期价格，展示分期价格
                                    if (item.productInstallment && item.productInstallment.installment > 0)
                                        return (
                                            <>
                                                <Text style={Styles.itemRow.infoRow.detailInfoCol.bottomRow.startPrice.label}>
                                                    {$k18n({ text: '每月', id: 'k_405796' })}
                                                </Text>
                                                <Text
                                                    numberOfLines={1}
                                                    ellipsizeMode={'tail'}
                                                    style={Styles.itemRow.infoRow.detailInfoCol.bottomRow.startPrice.price}
                                                >
                                                    {item.productInstallment.displayPaymentPerInstallment}
                                                </Text>
                                            </>
                                        );
                                    // 展示：起步价
                                    if (item.displayPrice !== item.maxPrice)
                                        return (
                                            <>
                                                <Text style={Styles.itemRow.infoRow.detailInfoCol.bottomRow.startPrice.label}>{$k18n('起')}</Text>
                                                <Text
                                                    numberOfLines={1}
                                                    ellipsizeMode={'tail'}
                                                    style={Styles.itemRow.infoRow.detailInfoCol.bottomRow.startPrice.price}
                                                >
                                                    {item.displayPrice}
                                                </Text>
                                            </>
                                        );
                                    // 展示：券后价
                                    else if (item.displayDeductionPrice)
                                        return (
                                            <>
                                                <Text
                                                    numberOfLines={1}
                                                    ellipsizeMode={'tail'}
                                                    style={Styles.itemRow.infoRow.detailInfoCol.bottomRow.couponPrice.price}
                                                >
                                                    {item.displayDeductionPrice}
                                                </Text>
                                                <Text style={Styles.itemRow.infoRow.detailInfoCol.bottomRow.couponPrice.label}>{$k18n('券后')}</Text>
                                            </>
                                        );
                                    // 展示：划线价
                                    else if (item.displayGuidePrice)
                                        return (
                                            <>
                                                <Text
                                                    numberOfLines={1}
                                                    ellipsizeMode={'tail'}
                                                    style={Styles.itemRow.infoRow.detailInfoCol.bottomRow.guidePrice.guide}
                                                >
                                                    {item.displayGuidePrice}
                                                </Text>
                                                <Text
                                                    numberOfLines={1}
                                                    ellipsizeMode={'tail'}
                                                    style={Styles.itemRow.infoRow.detailInfoCol.bottomRow.guidePrice.price}
                                                >
                                                    {item.displayPrice}
                                                </Text>
                                            </>
                                        );
                                    else
                                        return (
                                            <Text
                                                numberOfLines={1}
                                                ellipsizeMode={'tail'}
                                                style={Styles.itemRow.infoRow.detailInfoCol.bottomRow.guidePrice.price}
                                            >
                                                {item.displayPrice}
                                            </Text>
                                        );
                                })()}
                            </View>
                            {/* 产品诉求 已下架的商品 （item.itemShelfStatus == 1）
                                购买按钮要置灰 但还可以跳转 */}
                            <View
                                style={[
                                    Styles.actionBox.wrap,
                                    item.itemShelfStatus === 1
                                        ? Styles.itemRow.infoRow.buyBtnCol.needOpacity
                                        : Styles.itemRow.infoRow.buyBtnCol.notNeedOpacity,
                                ]}
                            >
                                {showCartProp ? (
                                    <TouchableOpacity
                                        style={[
                                            Styles.actionBox.cartBtn,
                                            (item.flashSaleStatus === EnumFlashSaleStatus.SoldOut ||
                                                item.flashSaleStatus === EnumFlashSaleStatus.SnatchUp ||
                                                item.inventory <= 0) &&
                                                Styles.actionBox.cartBtnDisabled,
                                        ]}
                                        activeOpacity={0.6}
                                        onPress={() => {
                                            // 库存为0、已下架，加购按钮需要置灰不可点击～不可加购
                                            if (item.inventory <= 0 || item.itemShelfStatus === 1) return;
                                            // 复用埋点
                                            // model.gotoDetail(item, 'cart'); 此处埋点拆分为成功or半屏，接口返回后上报
                                            // 加购
                                            setParams.setCurItemId(item.commodityId);
                                            setParams.setCurItem(item);
                                            setParams.setShowPop(true);
                                        }}
                                    >
                                        <MemoCartIcon />
                                    </TouchableOpacity>
                                ) : null}
                            </View>
                        </View>
                    </View>
                </View>
            </Animated.View>
        </ButtonWrapper>
    );
};
